(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-fade-nye"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nye-countdown')) {
    class NyeCountdown extends HTMLElement {
      connectedCallback() {
        var hours = parseFloat(this.dataset.liveHours);
        this.startTime = Date.parse(this.dataset.start || '');
        this.endTime = this.startTime + (isFinite(hours) ? hours : 6) * 3600000;
        this.liveEl = this.querySelector('.nye-count__live');
        this.units = {};
        this.querySelectorAll('[data-unit]').forEach(function (el) {
          this.units[el.dataset.unit] = el;
        }, this);
        this.tick = this.tick.bind(this);

        if (isNaN(this.startTime)) {
          this.setState('after');
          return;
        }
        this.tick();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      setState(state) {
        if (this.dataset.state !== state) this.dataset.state = state;
        if (this.liveEl) this.liveEl.hidden = state !== 'live';
      }

      setUnit(name, value) {
        var el = this.units[name];
        var text = value < 10 ? '0' + value : String(value);
        if (el && el.textContent !== text) el.textContent = text;
      }

      tick() {
        var now = Date.now();
        clearTimeout(this.timer);

        if (now >= this.endTime) {
          this.setState('after');
          return;
        }

        if (now >= this.startTime) {
          this.setState(this.liveEl ? 'live' : 'after');
          this.timer = setTimeout(this.tick, Math.min(this.endTime - now, 60000));
          return;
        }

        var total = Math.floor((this.startTime - now) / 1000);
        this.setState('before');
        this.setUnit('days', Math.floor(total / 86400));
        this.setUnit('hours', Math.floor((total % 86400) / 3600));
        this.setUnit('minutes', Math.floor((total % 3600) / 60));
        this.setUnit('seconds', total % 60);
        this.timer = setTimeout(this.tick, 1000 - (now % 1000) + 10);
      }
    }

    customElements.define('nye-countdown', NyeCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-fade-time100"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('t1-reels')) {
    class T1Reels extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting) {
                var played = video.play();
                if (played && played.catch) played.catch(function () {});
              } else {
                video.pause();
              }
            });
          }, { threshold: 0.35 });
          this.querySelectorAll('video').forEach(function (video) { this.observer.observe(video); }, this);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.observer) this.observer.disconnect();
      }

      onClick(event) {
        var button = event.target.closest('.t1-reel__sound');
        if (!button) return;
        var video = button.closest('.t1-reel').querySelector('video');
        if (!video) return;
        var turnOn = video.muted;
        this.querySelectorAll('video').forEach(function (v) { v.muted = true; });
        this.querySelectorAll('.t1-reel__sound').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.textContent = 'Sound on';
        });
        if (turnOn) {
          video.muted = false;
          button.setAttribute('aria-pressed', 'true');
          button.textContent = 'Sound off';
          var played = video.play();
          if (played && played.catch) played.catch(function () {});
        }
      }
    }

    customElements.define('t1-reels', T1Reels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
